import * as React from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';
import type { FindingsSearch } from './findings-url';

const DEFAULT_VALUES = new Set<unknown>(['all', 'default']);

export function cleanFindingsSearch(
  search: Record<string, unknown>,
): Record<string, unknown> {
  const next = { ...search };
  for (const [key, value] of Object.entries(next)) {
    if (
      value === undefined ||
      value === '' ||
      DEFAULT_VALUES.has(value) ||
      (key === 'page' && value === 1)
    ) {
      delete next[key];
    }
  }
  return next;
}

export function useFindingsUpdateSearch() {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as FindingsSearch;

  return React.useCallback(
    (patch: Partial<FindingsSearch>) => {
      const next: Record<string, unknown> = { ...search, ...patch };
      if (!Object.prototype.hasOwnProperty.call(patch, 'page')) {
        delete next.page;
      }
      // Let the active click/focus event finish before TanStack Router swaps
      // the findings query state. Chrome can otherwise wedge the renderer on
      // status-filter transitions with the segmented button still active.
      window.setTimeout(() => {
        navigate({
          search: cleanFindingsSearch(next),
          replace: true,
        } as unknown as Parameters<typeof navigate>[0]);
      }, 0);
    },
    [navigate, search],
  );
}
